import { getStore } from "../store/store";

export const getLocalKeytipsEnabledStatus = (): boolean => getStore().enabledKeytips;
